import React from "react";
import { FormPropsType } from "../Editor/Editor";
import { Container, Grid } from "@mantine/core";

export default (props: FormPropsType) => {
    return <>
        <Grid>
            <Grid.Col xs={1}>{props.fields.id}</Grid.Col>
            <Grid.Col xs={2}>{props.fields.serialnumber}</Grid.Col>
            <Grid.Col xs={3}>{props.fields.name}</Grid.Col>
            <Grid.Col xs={2}>{props.fields.width}</Grid.Col>
            <Grid.Col xs={2}>{props.fields.height}</Grid.Col>
            <Grid.Col xs={2}>{props.fields.wave_direction}</Grid.Col>
            <Grid.Col xs={6}>{props.fields.project}</Grid.Col>
            <Grid.Col xs={6}>{props.fields.storage_space}</Grid.Col>
            <Grid.Col xs={12}>{props.fields.preview}</Grid.Col>
        </Grid>
    </>
}